import { ActionIcon, Avatar, Header as BaseHeader, Box, Button, createStyles, Flex, Group, Menu, Modal, Text, UnstyledButton } from "@mantine/core";
import { IconChevronDown, IconKey, IconLogin, IconLogout, IconQuestionMark } from "@tabler/icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AuthApi } from "../../apis";
import { ReactComponent as Logo } from "../../assets/DigitalEra.svg";
import noimage from "../../assets/no-image.png";
import { authChange, authMe } from "../../store/Auth";
import HttpHandler from "../../utils/http-handler";
import { Message } from "../../utils/message";
import { CommingSoon } from "../layout/comming-soon";
import { Changepassword } from "../settings/change-password";
import { ChangePin } from "../settings/change-pin";

export const Header = () => {
  const { classes, theme } = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [action, setAction] = React.useState<any>([]);

  const { user, sessionScope } = useSelector((state: any) => state.auth);

  const LogOut = async () => {
    try {
      await AuthApi.logout();

      const removeToken = { accessToken: null };
      const removeUser = {};
      dispatch(authChange(removeToken as any));
      dispatch(authMe(removeUser as any));
      navigate("/auth/login");
    } catch (err) {
      Message.error((err as HttpHandler)?.message!);
    }
  };

  return (
    <>
      <BaseHeader className={classes.header} height={{ base: 62, md: 68 }}>
        <div className={classes.row}>
          {sessionScope !== "AUTHORIZED" ? (
            <>
              <div className={classes.logo}>
                <Logo />
              </div>
              <Flex gap="md" justify="flex-end" align="center" direction="row" wrap="wrap" mr={40}>
                <CommingSoon position="bottom" visible={true}>
                  <ActionIcon radius="xl" variant="outline" color="indigo.1">
                    <IconQuestionMark />
                  </ActionIcon>
                </CommingSoon>
                <CommingSoon position="bottom" visible={true}>
                  <Button variant="outline" color="indigo.1">
                    Заавар үзэх
                  </Button>
                </CommingSoon>
              </Flex>
            </>
          ) : (
            <>
              <Link to="/">
                <div className={classes.logo}>
                  <Logo />
                </div>
              </Link>
              <Menu width={260} position="bottom-end" transition="pop-top-right">
                <Menu.Target>
                  <UnstyledButton className={classes.user}>
                    <Group>
                      <Avatar src={user?.avatar || noimage} radius="xl" />
                      <div style={{ flex: 1 }}>
                        <Group>
                          <Text size="sm" weight={500} c="#f3f5f7">
                            {user?.lastName !== null ? user?.lastName : ""} {user?.firstName !== null ? user?.firstName : "-"}
                          </Text>
                        </Group>
                        <Text size="sm" weight={500} c="#c3cad4">
                          {user?.email || "-"}
                        </Text>
                      </div>
                      <IconChevronDown color="white" size={14} stroke={1.5} />
                    </Group>
                  </UnstyledButton>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Item onClick={() => setAction([true, "pin"])} icon={<IconKey size={20} color={theme.colors.yellow[6]} stroke={1.5} />}>
                    Пин код
                  </Menu.Item>
                  <Menu.Item onClick={() => setAction([true, "password"])} icon={<IconLogin size={20} color={"#3e166e"} stroke={1.5} />}>
                    Нууц үг
                  </Menu.Item>
                  <Menu.Divider />
                  <Menu.Item color="red" onClick={() => LogOut()} icon={<IconLogout size={20} stroke={1.5} />}>
                    Системээс гарах
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </>
          )}
        </div>
      </BaseHeader>
      <Modal opened={action[0]} onClose={() => setAction([])} centered withCloseButton={false}>
        <Box>
          {action[1] === "pin" && <ChangePin onClose={() => setAction([])} />}
          {action[1] === "password" && <Changepassword onClose={() => setAction([])} />}
        </Box>
      </Modal>
    </>
  );
};

export default Header;

const useStyles = createStyles((theme) => ({
  header: {
    display: "flex",
    flexDirection: "row",
    justifyItems: "center",
    alignItems: "center",
    backgroundColor: "#34105e",
    border: 0,
  },
  logo: {
    display: "flex",
    height: "50px",
    justifyContent: "end",
    alignItems: "end",
    marginTop: "10px",
    paddingLeft: "40px",
  },
  subTitle: {
    display: "flex",
    fontSize: 20,
    fontWeight: 600,
    color: "red",
    marginBottom: "-5px",
  },
  row: {
    display: "flex",
    justifyItems: "center",
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
    flexDirection: "row",
    zIndex: 10,
  },
  user: {
    padding: theme.spacing.xs,
    color: theme.black,
    "&:hover": {
      backgroundColor: "#e3181810",
    },
    borderColor: "#e60c0c",
  },
  userActive: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
  },
}));
